<template>
  <!-- 组件 -->
  <div class="confirmation">
    <img
      class="confirmation_img"
      src="@/assets/home_images/tijiao_chenggong_icon.png"
      alt=""
    />
    <div class="confirmat_title">提交订单成功</div>
    <div class="confirmat_content" v-if="!pushTarget">
      该订单已自动生成二维码，您可邀请实际承运人，扫码接单。
      如有疑问请拨打客服热线{{ branch.telephone }}
    </div>
    <div class="confirmat_content" v-else>
      <p>该订单为指派单，实际承运人可直接接单。</p>

      如有疑问请拨打客服热线{{ branch.telephone }}
    </div>

    <div class="operate_list">
      <el-button class="operate_but" type="info" plain @click="checkOrder()"
        >查看我的订单</el-button
      >
      <el-button
        class="operate_but"
        :type="subType ? 'info' : 'primary'"
        :disabled="subType"
        v-if="!pushTarget"
        @click="downCode()"
        >下载二维码
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "confirmation",
  props: {
    value: {
      type: String,
      default: ""
    },
    pushTarget: {
      type: String,
      default: ""
    },
    subType: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      branch: {
        telephone: ""
      }
    };
  },
  //过滤器
  filters: {},
  // 计算属性
  computed: {},
  // 监听器
  watch: {},
  //生命周期 创建后
  created() {},
  // 挂载后
  mounted() {
    let info = JSON.parse(localStorage.getItem("dataBranch"));
    this.branch = info;
  },
  // 销毁前
  beforeDestroy() {},
  //自定义函数
  methods: {
    checkOrder() {
      this.$emit("seeDetailRef");
      // this.$message({
      //   message: "敬请期待！",
      //   type: "warning",
      // });
    },
    downCode() {
      this.$emit("downCode");
    }
  }
};
</script>

<style scoped lang="scss">
.confirmation {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .confirmation_img {
    width: 64px;
    height: 64px;
  }
  .confirmat_title {
    margin-top: 24px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    font-size: 20px;
    color: rgba(0, 0, 0, 0.9);
    line-height: 28px;
  }
  .confirmat_content {
    width: 336px;
    margin-top: 8px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.6);
    line-height: 22px;
    text-align: center;
  }
  .operate_list {
    margin-top: 32px;
    .operate_but {
    }
  }
}
</style>
